import { useEffect } from "react";

const useDisableRightClickAndF12 = () => {
  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    const handleKeyDown = (event) => {
      // F12 key
      if (event.keyCode === 123) {
        event.preventDefault();
      }
      // Ctrl+Shift+I (Chrome DevTools)
      if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
        event.preventDefault();
      }
      // Ctrl+Shift+J (Chrome DevTools)
      if (event.ctrlKey && event.shiftKey && event.keyCode === 74) {
        event.preventDefault();
      }
      // Ctrl+U (View Source)
      if (event.ctrlKey && event.keyCode === 85) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};

export default useDisableRightClickAndF12;
